import React from 'react';
import ReactMarkdown from 'react-markdown';
import type { UserMessage as AgUiUserMessage } from '@ag-ui/client';
import styles from './render-messages.module.scss';

/** Renders the user's message as a right-aligned bubble. */
export function UserMessage({ message }: { message: AgUiUserMessage }) {
  // AG-UI allows multimodal content parts; panda only ever sends plain strings.
  const text = typeof message.content === 'string' ? message.content : '';

  return (
    <div className={styles.questionRow}>
      <div className={styles.questionBubble}>
        <ReactMarkdown className={styles.questionContent}>{text}</ReactMarkdown>
      </div>
    </div>
  );
}
